module.exports = __webpack_public_path__ + "img/Impacts to VECs-Cumulative impact assessment.9759aa1d.svg";